<template lang="pug">
	v-tabs(next-icon='mdi-arrow-right-bold-box-outline', v-model="tab", prev-icon='mdi-arrow-left-bold-box-outline', show-arrows)
		v-tabs-slider(color='blue-grey darken-3')
		v-tab(v-for='(i,index) in getTabs', :key='index', @click='$router.push(i.rota)')
			v-icon.icon-home {{i.icon}}
			| &#x9;{{ i.nome }}
		v-tabs-items
			v-card
				transition(name="component-fade" mode="out-in")
					router-view

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	data(){
		return{
            tab: null,
            tabs:[]
		}
    },
    updated()
    {
        if(this.$route.name == "pxtalk")
        {
            this.$router.push(`/${this.getTabs[0].rota}`)
            this.tab = 0
        }
    },
	mounted()
	{
        this.tabs = this.$route.meta.subroutes
        this.$router.push(`/${this.getTabs[0].rota}`)
        this.listaChamados()
        this.getGroupsManager()
        //this.listaGrupos()
    },
    computed:{
        ...mapGetters(['getChildren']),
        getTabs()
        {
            return this.getChildren.filter( m => this.tabs.find( t => t == m.rota && m.acoes.filter( a => a.status == true ).length > 0 ) )
        }
    },
    methods: {
        ...mapActions(['listaChamados', 'listaGrupos', 'getGroupsManager'])
    }
}
</script>

<style scoped lang="stylus">
	.icon-home
		font-size 1.5em
		margin-right 10px

	.alignTab
		display flex
		align-items center

</style>





// WEBPACK FOOTER //
// src/components/user/Pxtalk.vue